import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export const Route = createFileRoute("/modelformulier-herroeping")({
  head: () => ({
    meta: [
      { title: "Modelformulier voor herroeping — Elvion Group Nederland" },
      { name: "description", content: "Download het modelformulier voor herroeping van Elvion Group Nederland. Vul het formulier in en stuur het per e-mail of post om uw aankoop binnen 14 dagen te herroepen." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Modelformulier voor herroeping — Elvion Group Nederland" },
      { property: "og:description", content: "Officieel modelformulier voor herroeping van Elvion Group Nederland. Alleen invullen als u de overeenkomst wilt herroepen." },
      { property: "og:url", content: "https://elvion-group.nl/modelformulier-herroeping" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Modelformulier voor herroeping — Elvion Group Nederland" },
      { name: "twitter:description", content: "Download en verstuur het modelformulier voor herroeping van Elvion Group Nederland." },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/modelformulier-herroeping" }],
  }),
  component: () => (
    <LegalLayout
      title="Modelformulier voor herroeping"
      intro="Dit formulier alleen invullen en terugzenden als u de overeenkomst wilt herroepen. Gebruik van het formulier is niet verplicht — een duidelijke e-mail waarin u aangeeft af te zien van de aankoop volstaat volledig."
    >
      <div className="not-prose mb-8 flex flex-wrap gap-3 print:hidden">
        <Button onClick={() => window.print()} className="gap-2">
          <Printer className="size-4" />
          Printen of opslaan als PDF
        </Button>
        <Button asChild variant="outline">
          <a href={`mailto:${COMPANY.email}?subject=Herroeping%20-%20ordernummer`}>
            Mail direct naar {COMPANY.email}
          </a>
        </Button>
      </div>

      <h2>Aan</h2>
      <p>
        <strong>{COMPANY.name}</strong><br />
        t.a.v. Retouren / Herroeping<br />
        {COMPANY.address}<br />
        {COMPANY.postal} {COMPANY.country}<br />
        E-mail: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a><br />
        Telefoon: {COMPANY.phone}<br />
        KvK: {COMPANY.kvk} · BTW: {COMPANY.btw}
      </p>

      <h2>Verklaring</h2>
      <p>Ik/wij (*) deel/delen (*) u hierbij mede dat ik/wij (*) onze overeenkomst betreffende de verkoop van de volgende goederen/levering van de volgende dienst (*) herroep/herroepen (*):</p>

      <div className="not-prose my-6 rounded-lg border border-border p-4">
        <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-[220px_1fr]">
          <dt className="font-semibold">Besteld op (*) / ontvangen op (*)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Ordernummer (ORD-…)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Omschrijving product(en)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Naam consument(en)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Adres consument(en)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">E-mailadres</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">IBAN (indien afwijkend)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Handtekening (alleen op papier)</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>

          <dt className="font-semibold">Datum</dt>
          <dd className="border-b border-dashed border-muted-foreground/40 pb-2">&nbsp;</dd>
        </dl>
        <p className="mt-4 text-xs text-muted-foreground">(*) Doorhalen wat niet van toepassing is.</p>
      </div>

      <h2>Hoe verstuurt u dit formulier?</h2>
      <ul>
        <li><strong>Per e-mail (voorkeur):</strong> sla deze pagina op als PDF met de knop hierboven en mail deze naar <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</li>
        <li><strong>Per post:</strong> print het formulier, vul het in en stuur het naar het adres bovenaan.</li>
      </ul>

      <h2>Meer informatie</h2>
      <p>Zie ons <a href="/retourbeleid">retourbeleid</a> en de pagina over <a href="/bedenktijd">bedenktijd &amp; herroepingsrecht</a> voor de volledige uitwerking van het herroepingsproces.</p>
    </LegalLayout>
  ),
});
